import Vue from 'vue';
import Store from './vuex/store.js';
import VueLocalStorage from 'vue-localstorage';
import VueSessionStorage from 'vue-sessionstorage';
import Router from './router';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
//import VueLazyload from 'vue-lazyload'
import Utilities from './utilities';
import VueCookies from 'vue-cookies';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import VueGtm from 'vue-gtm';
import clickoutside from '@/directives/clickoutside';
import VueMeta from 'vue-meta';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/it.json';
import PersistentInput from './components/blocks/wrappers/persistent-input.vue';

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule], // assign message
  });
});
extend('confirm_email', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Gli indirizzi email non coincidono',
});
extend('price', {
  validate: (value, { decimals = '2', separator = '.' } = {}) => {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false,
      };
    }

    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      };
    }

    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

    return {
      valid: regex.test(value),
    };
  },
  message: 'Il campo {_field_} deve essere un importo valido',
});

// Custom rule for alphanumeric characters and spaces
extend('alpha_num_spaces', {
  validate(value) {
    return /^[A-Za-z0-9\xC0-\xFF\s']*$/.test(value);
  },
  message: 'Il campo {_field_} può contenere solo caratteri alfanumerici, numeri e spazi',
});

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);
Vue.component('persistent-input', PersistentInput);

Vue.directive('on-click-outside', clickoutside);

Vue.prototype.window = window;
Vue.config.productionTip = false;
window.eventBus = new Vue(); //catch events from api.js

Vue.use(VueCookies);
Vue.$cookies.config('30d');
Vue.use(VueLocalStorage);
Vue.use(VueSessionStorage);
//Vue.use(VueLazyload, {})
Vue.use(BootstrapVue); //, {breakpoints: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']})
Vue.mixin(Utilities);
Vue.use(VueVirtualScroller);

Vue.use(VueGtm, {
  id: process.env.VUE_APP_TAG_MANAGER, // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  /*queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
      gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
      gtm_preview:'env-4',
      gtm_cookies_win:'x'
    },*/
  enabled: process.env.VUE_APP_TAG_MANAGER_ENABLED == 'true', // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: process.env.VUE_APP_DEBUG == 'true', // Whether or not display console logs debugs (optional)
  loadScript: process.env.VUE_APP_TAG_MANAGER_ENABLED == 'true', // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: Router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // If router, you can exclude some routes name (case insensitive) (optional)
});

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

Vue.use(require('vue-moment'));

/* saves the WHOLE state in localstorage after every mutation
Store.subscribe((mutation, state) => {
    Vue.localStorage.set(process.env.VUE_APP_STORE_KEY, JSON.stringify(state))
})
*/

/* salvataggio del token in localstorage -> SPOSTATA DENTRO vuex/store.js
// saves ONLY THE TOKEN from state in localstorage after every mutation
Store.subscribe((mutation, state) => {
    if(mutation.type !== 'token') return
    let new_state = {
        token: state.token
    }
    Vue.localStorage.set(process.env.VUE_APP_STORE_KEY, JSON.stringify(new_state))
})
*/

Vue.config.performance = process.env.VUE_APP_MODE == 'development' ? true : false;

Vue.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  value = value.toLowerCase();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('uppercase', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.toUpperCase();
});

Vue.filter('lowercase', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.toLowerCase();
});

new Vue({
  router: Router,
  el: '#app',
  store: Store,
  mixins: [Utilities],
  render: (h) => h(App),
  beforeCreate() {
    //Vue.prototype.$config = {}
  },
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  update() {},
  beforeDestroy() {},
  destroyed() {},
});

if (
  (process.env.VUE_APP_MODE == 'staging' || process.env.VUE_APP_MODE == 'production') &&
  process.env.VUE_APP_SENTRY_DSN
) {
  Sentry.init({
    Vue,
    environment: process.env.VUE_APP_MODE,
    //dsn: "https://20fb142ff5784ae88f8bb0d9fa506d63@o770004.ingest.sentry.io/5795292",
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(Router),
        tracingOrigins: ['localhost', 'voli.vadobay.com', 'stag.voli.vadobay.com', /^\//],
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: process.env.VUE_APP_MODE == 'production' ? 0.2 : 1.0,
    debug: process.env.VUE_APP_MODE == 'development',
    tracingOptions: {
      trackComponents: true,
    },

    // Vue specific
    trackComponents: [],
    hooks: [],
    logErrors: process.env.VUE_APP_MODE == 'production' ? false : true, // altrimenti non passa gli errori in dev console
    attachProps: true,
    attachStacktrace: true,
  });
}
